import Copy from './Copy';
import Cta, { ctaProps } from './Cta';

import v1 from '../assets/vouchers/voucher_1.webp';
import v2 from '../assets/vouchers/voucher_2.webp';
import v3 from '../assets/vouchers/voucher_3.webp';
import v4 from '../assets/vouchers/voucher_4.webp';
import v5 from '../assets/vouchers/voucher_5.webp';
import v6 from '../assets/vouchers/voucher_6.webp';
import v7 from '../assets/vouchers/voucher_7.webp';
import v8 from '../assets/vouchers/voucher_8.webp';
import v9 from '../assets/vouchers/voucher_9.webp';
import v10 from '../assets/vouchers/voucher_10.webp';
import v11 from '../assets/vouchers/voucher_11.webp';
import v12 from '../assets/vouchers/voucher_12.webp';
import v13 from '../assets/vouchers/voucher_13.webp';

const TICKETS = [v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13];

/* Voucher offer copy (API `vouchers` section), an auto-scrolling marquee of
   brand voucher tickets, and the "view more" CTA. The marquee is decorative and
   the CTA opens the native Brands screen. */
export default function VouchersSection({ data, onAction }) {
  const openVouchers = () => onAction('VOUCHERS');

  // The track is rendered twice so the loop is seamless (translateX(-50%)).
  const loop = [...TICKETS, ...TICKETS];

  return (
    <section className="bbd-vouchers">
      <p className="bbd-copy"><Copy text={data.text} highlight={data.highlight} /></p>

      <div className="bbd-vmarquee" onClick={openVouchers} role="presentation">
        <div className="bbd-vmarquee-track">
          {loop.map((src, i) => (
            <img key={i} className="bbd-vmarquee-ticket" src={src} alt="" aria-hidden="true" />
          ))}
        </div>
      </div>

      <Cta {...ctaProps(data.cta, onAction)} />
    </section>
  );
}
